/* tslint:disable */
/* eslint-disable */
/**
 * Search API
 * Search
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
import type { UpdatedField } from './';
import {
    UpdatedFieldFromJSON,
    UpdatedFieldFromJSONTyped,
    UpdatedFieldToJSON,
} from './';
import type { UpdatedFieldName } from './';
import {
    UpdatedFieldNameFromJSON,
    UpdatedFieldNameFromJSONTyped,
    UpdatedFieldNameToJSON,
} from './';

/**
 * 
 * @export
 * @interface DurationField
 */
export interface DurationField extends UpdatedField {
    /**
     * 
     * @type {number}
     * @memberof DurationField
     */
    value: number;
    /**
     * 
     * @type {string}
     * @memberof DurationField
     */
    unit: DurationFieldUnitEnum;
    /**
     * 
     * @type {boolean}
     * @memberof DurationField
     */
    fixed: boolean;
}


/**
 * @export
 */
export const DurationFieldUnitEnum = {
    Days: 'DAYS',
    Weeks: 'WEEKS',
    Months: 'MONTHS'
} as const;
export type DurationFieldUnitEnum = typeof DurationFieldUnitEnum[keyof typeof DurationFieldUnitEnum];


/**
 * Check if a given object implements the DurationField interface.
 */
export function instanceOfDurationField(value: object): value is DurationField {
    if (!('value' in value) || value['value'] === undefined) return false;
    if (!('unit' in value) || value['unit'] === undefined) return false;
    if (!('fixed' in value) || value['fixed'] === undefined) return false;
    return true;
}

export function DurationFieldFromJSON(json: any): DurationField {
    return DurationFieldFromJSONTyped(json, false);
}

export function DurationFieldFromJSONTyped(json: any, ignoreDiscriminator: boolean): DurationField {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldFromJSONTyped(json, ignoreDiscriminator),
        'value': json['value'],
        'unit': json['unit'],
        'fixed': json['fixed'],
    };
}

export function DurationFieldToJSON(value?: DurationField | null, ignoreDiscriminator?: boolean): any {
    if (value == null) {
        return value;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        ...UpdatedFieldToJSON(value, true),
        'value': value['value'],
        'unit': value['unit'],
        'fixed': value['fixed'],
    };
}

